import { render, staticRenderFns } from "./FerryPickupEdit.vue?vue&type=template&id=2461861a"
import script from "../../controllers/ferry_pickup/ferry-pickup-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/ferry_pickup/ferry-pickup-edit.js?vue&type=script&lang=js&external"
import style0 from "./FerryPickupEdit.vue?vue&type=style&index=0&id=2461861a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports